import React from 'react'


const Speech = props => (
	<svg {...props} viewBox="0 -1 16 17">
		<ellipse cx="8" cy="6.5" rx="8" ry="6.5" />
		<polygon points="1 15 3 10 5 12" />
	</svg>
)

export default Speech
